Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.SurveyEditAnswerTemplate = function () {
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'attributes': {
          'id': 'SurveyTemplateContainer',
        },
        'items': [
          {
            'items': [
              {
                'items': [
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'button',
                      'class': 'btn i18nResource btn-secondary',
                      'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.cancelButton'),
                      'id': 'EditFormCancelButton',
                    },
                  },
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'button',
                      'class': 'btn i18nResource',
                      'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.saveButton'),
                      'id': 'EditFormSaveButton',
                      'style': 'float:right;',
                    },
                  },
                ],
                'attributes': {
                  'class': 'buttonGroup',
                },
              },
              {
                'html': Monet.I18n.getResourcesByKey('Survey.edit.header'),
                'attributes': {
                  'class': 'editHeader',
                },
              },
              {
                'items': [
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'text',
                      'class': 'editInput',
                      'maxlength': '255',
                    },
                  },
                ],
                'attributes': {
                  'class': 'questionContent',
                },
              },
            ],
            'attributes': {
              'class': 'formContent',
            },
          },
        ],
      },
    ],
  }).render();
};
